import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 400px
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4 duration-300" data-id="element-150">
      <Button variant="secondary" size="lg" onClick={scrollToPricing} className="shadow-xl hover:shadow-2xl flex items-center gap-2" data-id="element-151">
        <span data-id="element-152">Comprar por $6.39</span>
        <ArrowDown className="w-5 h-5" data-id="element-153" />
      </Button>
    </div>;
}